import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'isOptionInSelections',
  standalone: true
})
export class IsOptionInSelectionsPipe<T> implements PipeTransform {
  transform(
    selections: T[],
    value: T,
    compareFn: (val1: T, val2: T) => boolean
  ): boolean {
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for (let i = 0; i < selections.length; i += 1) {
      if (!!value && compareFn(selections[i], value)) {
        return true;
      }
    }

    return false;
  }
}
